/* Upload Tee — theme.js
 * Minimal scaffolding. Section-specific JS will be added per section as needed.
 */
(function () {
  "use strict";

  // Update cart count on cart:updated events fired elsewhere
  document.addEventListener("cart:updated", function (e) {
    var count = (e && e.detail && typeof e.detail.itemCount === "number") ? e.detail.itemCount : null;
    if (count === null) return;
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = String(count);
    });
  });

  // Fade sticky CTA out near the footer to prevent overlap with footer content
  var cta = document.querySelector(".cta-bar");
  var footer = document.querySelector(".site-footer");
  if (cta && footer && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        cta.style.opacity = entry.isIntersecting ? "0" : "1";
        cta.style.pointerEvents = entry.isIntersecting ? "none" : "auto";
      });
    }, { rootMargin: "0px 0px -10% 0px" });
    io.observe(footer);
    cta.style.transition = "opacity 200ms ease";
  }
})();
